<template>
    <div class="w-layout-grid content-3-col-grid">
        <div class="side-content">
        </div>
        <div class="middle-content middle-content-initial-state">
            <div class="course-top">
                <div class="course-name-block">
                    <h2 class="section-title" v-if="isEdit">{{ trans('forms.studentGroup.edit_title') }}</h2>
                    <h2 class="section-title" v-else> {{ trans('forms.studentGroup.add_title') }}</h2>
                </div>
            </div>
            <form id="studentGroupForm" @submit.prevent="submit($event)">
                <input type="hidden" name="_token" :value="csrf">
                <div class="row">
                    <div class="col-6">
                        <div class="form-group ">
                            <label for="name" class="col-form-label">{{ trans('forms.studentGroup.name') }}</label>
                            <input id="name" type="text" v-model="studentGroup.name"
                                   class="form-control"
                                   :class="{'is-invalid': errors && errors.name}"
                                   name="name" required>
                            <span v-if="errors && errors.name" class="invalid-feedback" role="alert">
                                <strong v-for="error in errors.name">
                                    {{ error }}
                                </strong>
                            </span>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="form-group">
                            <label for="description" class="col-form-label">{{ trans('forms.studentGroup.description') }}</label>
                            <input id="description" type="text" v-model="studentGroup.description"
                                   class="form-control"
                                   :class="{'is-invalid': errors && errors.description}"
                                   name="description">
                            <span v-if="errors && errors.description" class="invalid-feedback" role="alert">
                                <strong v-for="error in errors.name">
                                    {{ error }}
                                </strong>
                            </span>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="form-check">
                            <input class="form-check-input" id="use_token" type="checkbox" :disabled="disableGenerateToken" v-model="studentGroup.use_token" :class="{'is-invalid': errors && errors.use_token}" name="description">
                            <label for="use_token" class="form-check-label">
                                {{ trans('forms.studentGroup.use_token') }}
                            </label>
                             <span v-if="errors && errors.use_token" class="invalid-feedback" role="alert">
                                <strong v-for="error in errors.name">
                                    {{ error }}
                                </strong>
                            </span>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="form-group" v-if="studentGroup.use_token">
                            <label for="token_use_limit" class="col-form-label">{{ trans('forms.studentGroup.token_modal_usage_limit_label') }}</label>
                            <input id="token_use_limit" type="number" v-model="studentGroup.token_use_limit"
                                   min="0"
                                   class="form-control"
                                   :class="{'is-invalid': errors && errors.token_use_limit}"
                                   name="description">
                            <span v-if="errors && errors.token_use_limit" class="invalid-feedback" role="alert">
                                <strong v-for="error in errors.name">
                                    {{ error }}
                                </strong>
                            </span>
                        </div>
                    </div>
                    <div class="col-12 mt-4">
                        <div class="row mb-4">
                            <div class="col-sm-6">
                                <label class="col-form-label">{{ trans('forms.studentGroup.allStudents') }}</label>
                            </div>
                            <div class="col-sm-6 text-right">
                              <label class="col-form-label">{{ trans('forms.studentGroup.studentGroup') }}</label>
                            </div>
                            <dual-list-box
                            :source="students"
                            :destination="studentGroup.students"
                            label="name"
                            @onChangeList="onChangeList"
                            ></dual-list-box>
                        </div>

                        <input type="hidden" name="id" :value="studentGroup.id">

                        <a :href="route('admin-student-group-management')" class="btn btn-danger">
                            {{ trans('forms.studentGroup.cancel_button') }}
                        </a>
                        <button type="submit" name="saveType" value="save" class="btn btn-success float-right">
                            {{ trans('forms.studentGroup.save_button') }}
                        </button>
                        <button v-if="isEdit" type="submit" name="saveType" value="apply" class="btn btn-primary float-right mr-2">
                            {{ trans('forms.studentGroup.apply_button') }}
                        </button>

                    </div>
                </div>
            </form>
        </div>
        <div class="side-content right side-right-initial-state">
        </div>
    </div>
</template>

<script>
import DualListBox from "dual-listbox-vue";
import "dual-listbox-vue/dist/dual-listbox.css";

export default {
    name: "StudentGroupEditor",
    components: {
        DualListBox
    },
    props: {
        studentGroupData: {
            type: Object,
        },
        formErrors: {
            type: Array,
            default: () => [],
        },
        allStudents: {
            type: Array,
            default: () => [],
        }
    },
    data: () => ({
        csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        studentGroup: {
            name: "",
            description: "",
            use_token: false,
            token_use_limit: 0,
            students: [],
        },
        errors: [],
        isEdit: false,
        students: [],
        disableGenerateToken: false,

    }),
    mounted() {
        $('input[placeholder="Search"]').attr('placeholder', window.trans.forms.studentGroup.search);
        $('.bulk-action .select-all').text(window.trans.forms.studentGroup.select_all);
        $('.bulk-action .deselect-all').text(window.trans.forms.studentGroup.deselect_all);
        if (this.studentGroupData.hasOwnProperty('id')) {
            this.isEdit = true
        }
        if (this.studentGroupData.token) {
            this.studentGroupData.use_token = true
            this.disableGenerateToken = true
        }

        this.studentGroup = this.studentGroupData
        this.errors = this.formErrors
        this.students = this.allStudents
        if ( !this.studentGroup.students ) {
            this.studentGroup.students = []
        }

    },
    methods: {
        onChangeList: function ({ source, destination }) {
            this.students = source;
            this.studentGroup.students = destination;
        },
        submit(event) {
            this.errors = {};
            axios.post('/save-student-group', this.studentGroup).then(() => {
                if (event.submitter.value === "save") {
                    location.href = "/admin/student-group-management";
                } else if (event.submitter.value === "apply") {
                    window.location.reload()
                }
            }).catch(error => {
                if (error.response.status === 422) {
                    this.errors = error.response.data.errors || {};
                    // console.log(this.errors)
                }
            });
        }
    }
}
</script>

<style scoped>

</style>
